var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99992 3.95831C4.42462 3.95831 3.95825 4.42468 3.95825 4.99998V15C3.95825 15.5753 4.42462 16.0416 4.99992 16.0416H14.9999C15.5752 16.0416 16.0416 15.5753 16.0416 15V4.99998C16.0416 4.42468 15.5752 3.95831 14.9999 3.95831H4.99992ZM2.70825 4.99998C2.70825 3.73433 3.73427 2.70831 4.99992 2.70831H14.9999C16.2656 2.70831 17.2916 3.73433 17.2916 4.99998V15C17.2916 16.2656 16.2656 17.2916 14.9999 17.2916H4.99992C3.73427 17.2916 2.70825 16.2656 2.70825 15V4.99998Z",
    fill: "#2B2B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 8.54169C7.01193 8.54169 7.29175 8.82151 7.29175 9.16669V13.3334C7.29175 13.6785 7.01193 13.9584 6.66675 13.9584C6.32157 13.9584 6.04175 13.6785 6.04175 13.3334V9.16669C6.04175 8.82151 6.32157 8.54169 6.66675 8.54169Z",
    fill: "#2B2B35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 6.04169C7.01193 6.04169 7.29175 6.32151 7.29175 6.66669V6.67502C7.29175 7.0202 7.01193 7.30002 6.66675 7.30002C6.32157 7.30002 6.04175 7.0202 6.04175 6.67502V6.66669C6.04175 6.32151 6.32157 6.04169 6.66675 6.04169Z",
    fill: "#2B2B35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.54169C10.3452 8.54169 10.625 8.82151 10.625 9.16669V13.3334C10.625 13.6785 10.3452 13.9584 10 13.9584C9.65482 13.9584 9.375 13.6785 9.375 13.3334V9.16669C9.375 8.82151 9.65482 8.54169 10 8.54169Z",
    fill: "#2B2B35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0462 9.2129C10.476 8.78313 11.0589 8.54169 11.6667 8.54169C12.2745 8.54169 12.8573 8.78313 13.2871 9.2129C13.7169 9.64267 13.9583 10.2256 13.9583 10.8334V13.3334C13.9583 13.6785 13.6785 13.9584 13.3333 13.9584C12.9882 13.9584 12.7083 13.6785 12.7083 13.3334V10.8334C12.7083 10.5571 12.5986 10.2921 12.4032 10.0968C12.2079 9.90143 11.9429 9.79169 11.6667 9.79169C11.3904 9.79169 11.1254 9.90143 10.9301 10.0968C10.7347 10.2921 10.625 10.5571 10.625 10.8334C10.625 11.1785 10.3452 11.4584 10 11.4584C9.65482 11.4584 9.375 11.1785 9.375 10.8334C9.375 10.2256 9.61644 9.64267 10.0462 9.2129Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1f4b6470f9e19fb64cd1f019358a7e57.svg";
export { ForwardRef as ReactComponent };